import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import { useAuthStore } from "@/stores/auth.store";

// ═══════════════════════════════════════════════════════════
// useTokenHealth — OAuth token health & connection status
// Only fetches when the user is authenticated (memberId known)
// ═══════════════════════════════════════════════════════════

export interface TokenHealthInfo {
  memberId: string;
  domain: string;
  tokenStatus: "ACTIVE" | "REFRESH_FAILED" | "REVOKED";
  expiresAt: number | null;
  lastRefreshedAt: number | null;
  serverEndpoint: string | null;
  isExpired: boolean;
  needsRefresh: boolean;
}

export function useTokenHealth() {
  const memberId = useAuthStore((s) => s.memberId);

  return useQuery({
    queryKey: queryKeys.tokenHealth,
    queryFn: () => api.get<TokenHealthInfo>("/api/admin/token-health"),
    enabled: !!memberId,
    staleTime: 60_000, // 1 minute — health status changes infrequently
    retry: 1,
  });
}
